import React from 'react';
import classNames from 'classnames';
import { useIsMobile } from '@hooks';
import s from './Admonition.module.scss';

interface Props {
  title: string;
  guidance?: string | React.ReactNode;
  hasBorder?: boolean;
}

const Admonition: React.FC<Props> = ({ title, guidance, hasBorder = true, children }) => (
  <div className={classNames(s.admonition, {[s['admonition--hasBorder']]: hasBorder})}>
    <details open={!useIsMobile()}>
      <summary className="action">{title}</summary>
      {guidance && <p className="body-sm">{guidance}</p>}
    </details>
    {children}
  </div>
);

export default Admonition;
